import getNavigationItems, { INavItem } from "@/navigation/navigation";
import { useUser } from "@/requests/hooks/user";
import { IFeatureFlagKeys } from "@/utils/featureFlags";
import { useFlags } from "flagsmith/react";
import { useEffect, useState } from "react";

const useNavigationMenu = (): INavItem[] => {
  const { data: userData } = useUser();

  const flags = useFlags<IFeatureFlagKeys>([
    "collect-sms-health-enabled",
    "collect-sms-health-history-enabled",
    "web-app-mat-onboarding-enabled",
  ]);

  const [navigation, setNavigation] = useState<INavItem[]>([]);

  useEffect(() => {
    if (!userData) return;

    const navigationItems = getNavigationItems({
      scopes: userData.scopes,
      flags,
    });

    setNavigation(navigationItems);
  }, [userData, flags]);

  return navigation;
};

export default useNavigationMenu;
